import React from 'react';

import { ReportsTable } from '../inspection/components/';
import MobileReportsList from '../reports/components/MobileReportsList';

import Hidden from 'material-ui/Hidden';
const Dashboard = props => {
  return (
    <div>
      <Hidden smDown>
        <ReportsTable {...this.props} />
      </Hidden>
      <Hidden mdUp>
        <MobileReportsList />
      </Hidden>
    </div>
  );
};

/**
 *   xsUp?: boolean;
 smUp?: boolean;
 mdUp?: boolean;
 lgUp?: boolean;
 xlUp?: boolean;
 xsDown?: boolean;
 smDown?: boolean;
 mdDown?: boolean;
 lgDown?: boolean;
 xlDown?: boolean;
 */

export default Dashboard;



// WEBPACK FOOTER //
// ./src/modules/pages/Dashboard.js